import React from 'react';
import useMapStore from '@store/useMapStore';
import { TILE_SIZE } from '@utils/constants';
import './CoordinateLink.css';

/**
 * CoordinateLink - Interactive coordinate display that highlights map tiles on hover
 *
 * - Hover: Highlights the tile on the map with golden outline
 * - Click: Centers the map view on that tile
 *
 * @param {number} x - X coordinate of the tile
 * @param {number} y - Y coordinate of the tile
 * @param {string} [className] - Additional CSS classes
 */
const CoordinateLink = ({ x, y, className = '' }) => {
  const setFocusTile = useMapStore((state) => state.setFocusTile);
  const centerOnTile = useMapStore((state) => state.centerOnTile);

  const handleMouseEnter = () => {
    console.log('[CoordinateLink] mouseEnter, setting focusTile:', { x, y });
    setFocusTile({ x, y });

    // Log the focus tile element if it exists
    setTimeout(() => {
      const focusTileEl = document.querySelector('.highlight-tile.focus-tile');
      console.log('[CoordinateLink] focus-tile element:', focusTileEl);
      if (focusTileEl) {
        console.log('[CoordinateLink] focus-tile style:', focusTileEl.style.cssText);
        console.log('[CoordinateLink] focus-tile computed:', window.getComputedStyle(focusTileEl).outline);
      }
    }, 100);
  };

  const handleMouseLeave = () => {
    console.log('[CoordinateLink] mouseLeave, clearing focusTile');
    setFocusTile(null);
  };

  const handleClick = () => {
    console.log('[CoordinateLink] click, centering on tile:', { x, y, TILE_SIZE });
    centerOnTile(x, y, TILE_SIZE);
  };

  return (
    <span
      className={`coordinate-link ${className}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      ({x}, {y})
    </span>
  );
};

export default CoordinateLink;
